export const states = [
    { value: 'AC',
        estado: 'Acre' },
    { value: 'AL',
        estado: 'Alagoas' },
    { value: 'AP',
        estado: 'Amapá' },
    { value: 'AM',
        estado: 'Amazonas' },
    { value: 'BA',
        estado: 'Bahia' },
    { value: 'CE',
        estado: 'Ceará' },
    { value: 'DF',
        estado: 'Distrito Federal' },
    { value: 'ES',
        estado: 'Espírito Santo' },
    { value: 'GO',
        estado: 'Goías' },
    { value: 'MA',
        estado: 'Maranhão' },
    { value: 'MT',
        estado: 'Mato Grosso' },
    { value: 'MS',
        estado: 'Mato Grosso do Sul' },
    { value: 'MG',
        estado: 'Minas Gerais' },
    { value: 'PA',
        estado: 'Pará' },
    { value: 'PB',
        estado: 'Paraíba' },
    { value: 'PR',
        estado: 'Paraná' },
    { value: 'PE',
        estado: 'Pernambuco' },
    { value: 'PI',
        estado: 'Piauí' },
    { value: 'RJ',
        estado: 'Rio de Janeiro' },
    { value: 'RN',
        estado: 'Rio Grande do Norte' },
    { value: 'RS',
        estado: 'Rio Grande do Sul' },
    { value: 'RO',
        estado: 'Rondônia' },
    { value: 'RR',
        estado: 'Roraíma' },
    { value: 'SC',
        estado: 'Santa Catarina' },
    { value: 'SP',
        estado: 'São Paulo' },
    { value: 'SE',
        estado: 'Sergipe' },
    { value: 'TO',
        estado: 'Tocantins' }
];